import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SPINNER } from '../../tokens/http-context.tokens';

@Injectable({
  providedIn: 'root'
})
export class SearchDataService {

  private universalSearchapiUrl = `${environment.common}/entities/search`;
  private personSearchapiUrl = `${environment.travel}/personsearch`;

  constructor(
    private _http: HttpClient
  ) { }

  searchDataInModule(entitytype:any,keyword:any){
    return this._http.get<any>(`${this.universalSearchapiUrl}?entitytype=${entitytype}&keyword=${keyword}`);
  }

  searchPersonByType(type:any, keyword:any):Observable<any>{    
    return this._http.get<any>(`${this.personSearchapiUrl}/${type}/${keyword}`, {
      context: new HttpContext().set(SPINNER, false) // Passing flag
    });
  }
}
